import { CloseOutlined } from '@teko/ds-icon';
import React__default, { useEffect } from 'react';
import { useTransition, animated } from 'react-spring';
import { Title } from '../Typography/index.es.js';
import { Modal as Modal$1 } from './OldModal.es.js';
import { Overlay } from './Overlay.es.js';
import { getScrollbarWidth, mergeCls, uid } from '../../helpers/utils.es.js';
import { Button } from '../Button/Button.es.js';
import styled from '@emotion/styled';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Modal = (_a) => {
  var _b = _a, {
    onClose,
    onBackDrop,
    visible,
    title,
    children,
    footer = true,
    width,
    maxWidth,
    style,
    contentStyle,
    onOk,
    onCancel,
    okText,
    cancelText,
    okButtonProps,
    cancelButtonProps,
    showCloseIcon = true,
    centeredTitle = false,
    centeredBody = false,
    alignFooter = "right",
    fullWidthFooter = false,
    closable = true,
    overlayRef,
    zIndex,
    disableEscClose = true,
    overlayAlignItems,
    overlayJustifyContent
  } = _b, rest = __objRest(_b, [
    "onClose",
    "onBackDrop",
    "visible",
    "title",
    "children",
    "footer",
    "width",
    "maxWidth",
    "style",
    "contentStyle",
    "onOk",
    "onCancel",
    "okText",
    "cancelText",
    "okButtonProps",
    "cancelButtonProps",
    "showCloseIcon",
    "centeredTitle",
    "centeredBody",
    "alignFooter",
    "fullWidthFooter",
    "closable",
    "overlayRef",
    "zIndex",
    "disableEscClose",
    "overlayAlignItems",
    "overlayJustifyContent"
  ]);
  const onCloseModal = () => {
    if (!closable)
      return;
    if (typeof onClose === "function") {
      onClose == null ? void 0 : onClose();
    }
    if (typeof onBackDrop === "function") {
      onBackDrop == null ? void 0 : onBackDrop();
    }
  };
  const closeOnEscapeKeyDown = (e) => {
    if (!closable || disableEscClose)
      return;
    if ((e.charCode || e.keyCode) === 27) {
      onCloseModal();
    }
  };
  const transitions = useTransition(visible, {
    from: { opacity: 0, transform: "translateY(-40px)" },
    enter: { opacity: 1, transform: "translateY(0px)" },
    leave: { opacity: 0, transform: "translateY(-40px)" }
  });
  useEffect(() => {
    document.body.addEventListener("keydown", closeOnEscapeKeyDown);
    return function cleanup() {
      document.body.removeEventListener("keydown", closeOnEscapeKeyDown);
    };
  }, []);
  useEffect(() => {
    if (typeof document !== "undefined") {
      const currentModals = document.querySelectorAll('*[id^="teko-modal"]');
      if (currentModals.length) {
        document.body.style.overflow = "hidden";
        document.body.style.paddingRight = `${getScrollbarWidth()}px`;
      }
    }
    return () => {
      document.body.style.overflow = "unset";
      document.body.style.paddingRight = "unset";
    };
  }, [visible]);
  const renderFooter = () => {
    if (footer === false || footer === null || footer === void 0) {
      return null;
    }
    const footerCls = mergeCls("teko-modal-footer", `teko-modal-footer-${alignFooter}`);
    if (footer === true) {
      const style2 = fullWidthFooter ? { flex: 1 } : {};
      return /* @__PURE__ */ React__default.createElement("div", {
        className: footerCls
      }, cancelText !== "" && /* @__PURE__ */ React__default.createElement(Button, __spreadProps(__spreadValues({
        marginRight: okText !== "" ? "s12" : "s0",
        onClick: () => onCancel == null ? void 0 : onCancel()
      }, cancelButtonProps), {
        style: __spreadValues(__spreadValues({}, cancelButtonProps == null ? void 0 : cancelButtonProps.style), style2)
      }), cancelText || "Cancel"), okText !== "" && /* @__PURE__ */ React__default.createElement(Button, __spreadProps(__spreadValues({
        variant: "primary",
        onClick: () => onOk == null ? void 0 : onOk()
      }, okButtonProps), {
        style: __spreadValues(__spreadValues({}, okButtonProps == null ? void 0 : okButtonProps.style), style2)
      }), okText || "OK"));
    }
    return /* @__PURE__ */ React__default.createElement("div", {
      className: footerCls
    }, footer);
  };
  const modalCls = mergeCls("teko-modal", visible ? "teko-modal-show" : "", rest.className || "");
  const modalTitleCls = mergeCls("teko-modal-title", centeredTitle ? "teko-modal-title-centered" : "");
  const modalBodyCls = mergeCls("teko-modal-body", centeredBody ? "teko-modal-body-centered" : "");
  if (typeof (rest == null ? void 0 : rest.show) !== "undefined") {
    const oldModalProps = __spreadProps(__spreadValues({}, rest), {
      children,
      width
    });
    return /* @__PURE__ */ React__default.createElement(Modal$1, __spreadValues({}, oldModalProps));
  }
  return /* @__PURE__ */ React__default.createElement(Overlay, {
    show: !!visible,
    onEscPressed: () => {
      if (!disableEscClose)
        onCloseModal();
    },
    id: `teko-modal-${uid()}`,
    zIndex,
    alignItems: overlayAlignItems,
    justifyContent: overlayJustifyContent
  }, /* @__PURE__ */ React__default.createElement(Backdrop, {
    onClick: onCloseModal
  }), transitions((styles, item) => item && /* @__PURE__ */ React__default.createElement(AnimatedModal, __spreadProps(__spreadValues({
    className: modalCls,
    style: __spreadValues(__spreadValues(__spreadValues({}, styles), !!width ? { width } : {}), style)
  }, rest), {
    ref: overlayRef,
    maxWidth
  }), /* @__PURE__ */ React__default.createElement("div", {
    className: "teko-modal-content",
    style: __spreadValues({}, contentStyle),
    onClick: (e) => e.stopPropagation()
  }, showCloseIcon && /* @__PURE__ */ React__default.createElement(CloseOutlined, {
    className: "teko-modal-close",
    size: 24,
    color: "#000000",
    onClick: onCloseModal
  }), title && /* @__PURE__ */ React__default.createElement("div", {
    className: "teko-modal-header"
  }, typeof title === "string" ? /* @__PURE__ */ React__default.createElement(Title, {
    level: 1,
    className: modalTitleCls
  }, title) : /* @__PURE__ */ React__default.createElement("div", {
    className: modalTitleCls
  }, title)), /* @__PURE__ */ React__default.createElement("div", {
    className: modalBodyCls
  }, children, renderFooter())))));
};
const Backdrop = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: -1000;
`;
const StyledModal = styled.div`
  width: ${({ size }) => modalSizes[size || "m"]};
  max-width: ${({ maxWidth }) => !!maxWidth ? maxWidth : "95%"};
  &.teko-modal-show {
    opacity: 1 !important;
    pointer-events: visible;
  }

  &.teko-modal-show .teko-modal-content {
    transform: translateY(0);
    z-index: 1050;
  }

  .teko-modal-content {
    padding: 24px;
    transition: all 0.2s ease-in-out;
    background-color: #ffffff;
    box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.05),
      0px 8px 16px rgba(0, 0, 0, 0.05);
    position: relative;
    border-radius: 8px;
    position: relative;

    .teko-modal-close {
      position: absolute;
      z-index: 1000;
      top: 24px;
      right: 24px;
      cursor: pointer;
    }

    .teko-modal-header {
      .teko-modal-title {
        margin-bottom: 24px;
        color: #1b1d29;
        &.teko-modal-title-centered {
          text-align: center;
        }
      }
    }

    .teko-modal-body {
      font-size: 13px;
      line-height: 20px;
      word-wrap: break-word;
      &.teko-modal-body-centered {
        text-align: center;
      }
    }

    .teko-modal-footer {
      margin-top: 24px;
      &.teko-modal-footer-right {
        display: flex;
        justify-content: flex-end;
      }
      &.teko-modal-footer-left {
        display: flex;
        justify-content: flex-start;
      }
      &.teko-modal-footer-center {
        display: flex;
        justify-content: center;
      }
    }
  }
`;
const AnimatedModal = animated(StyledModal);
AnimatedModal.defaultProps = {
  size: "m"
};
const modalSizes = {
  xs: "320px",
  s: "420px",
  m: "520px",
  l: "720px"
};

export { Modal };
